import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {
    openFirmware
} from '../reducers/modals';


import {
    openConnectedMenu,
    closeConnectedMenu,
    connectedMenuOpen
} from '../reducers/menus';

class RbFactoryReset extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClick'
        ]);
    }

    handleClick () {
        this.props.onRequestOpenFirmware();
    }

    render () {
        const {
            /* eslint-disable no-unused-vars */
            children,
            firmwareVisible,
            /* eslint-enable no-unused-vars */
            ...props
        } = this.props;
        return this.props.children(this.handleClick, this.props.firmwareVisible, props);
    }
}

RbFactoryReset.propTypes = {
    children: PropTypes.func,
    connectedMenuOpen: PropTypes.bool,
    firmwareVisible: PropTypes.bool,
    onClickConnection: PropTypes.func,
    onRequestCloseConnection: PropTypes.func,
    onRequestOpenFirmware: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    firmwareVisible: state.scratchGui.modals.firmware,
    connectedMenuOpen: connectedMenuOpen(state)
});

const mapDispatchToProps = dispatch => ({
    onRequestOpenFirmware: () => {
        dispatch(openFirmware());
    },
    onClickConnection: () => dispatch(openConnectedMenu()),
    onRequestCloseConnection: () => dispatch(closeConnectedMenu())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbFactoryReset);
